import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import isEmpty from 'lodash/isEmpty';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { getOptionIdValueFromKeyword } from '@uno/common-cms';
import { EntityPrefixes } from '@uno/common-seo';
import TagInput from 'components/common/TagInput';
import { useSiteConfig } from 'libs/common/hooks';
import { useSemanticScore, useSeoData } from 'libs/content/hooks';
import { FormHelperTextWarning, Keyword } from './YTGInputField.style';

var createOption = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(title, lang) {
    var keyword;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Here we do not create keyword right now because it's handled during the getScore process
            // We just build a fake object to build the TagOptions so it can be displayed to user
            keyword = {
              entity: 'Keyword',
              // Keyword.name,
              ytgGuideId: '',
              lang: lang,
              keyword: title
            };
            return _context.abrupt("return", Promise.resolve({
              id: getOptionIdValueFromKeyword(keyword),
              title: keyword.keyword
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createOption(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getRecommendedKeyword = function getRecommendedKeyword(seoData) {
  var _seoData$htmlTags;

  return seoData === null || seoData === void 0 ? void 0 : (_seoData$htmlTags = seoData.htmlTags) === null || _seoData$htmlTags === void 0 ? void 0 : _seoData$htmlTags.mainKeyword;
};

var YTGInputField = function YTGInputField(_ref2) {
  var _getRecommendedKeywor;

  var formField = _ref2.formField;

  var _useSiteConfig = useSiteConfig(),
      lang = _useSiteConfig.lang;

  var _useSemanticScore = useSemanticScore(lang),
      loading = _useSemanticScore.loading,
      options = _useSemanticScore.options;

  var _useSeoData = useSeoData([EntityPrefixes.TAGS]),
      seoDataLoading = _useSeoData.loading,
      seoData = _useSeoData.value;

  var formMethods = useFormContext();
  var inputValue = formMethods.getValues(formField.name);
  var selectedOption = options.find(function (option) {
    return option.id === (inputValue === null || inputValue === void 0 ? void 0 : inputValue[0]);
  });
  var canDisplayRecommendedKeyword = !seoDataLoading && !isEmpty(getRecommendedKeyword(seoData)) && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title.toLowerCase()) !== ((_getRecommendedKeywor = getRecommendedKeyword(seoData)) === null || _getRecommendedKeywor === void 0 ? void 0 : _getRecommendedKeywor.toLocaleLowerCase());
  return __jsx(React.Fragment, null, __jsx(TagInput, {
    labelId: formField.labelId,
    name: formField.name,
    options: options,
    multipleTag: false,
    loading: loading,
    freeSolo: true,
    removeInvalidValue: true,
    createOption: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(keyword) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return createOption(keyword, lang);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  }), canDisplayRecommendedKeyword && __jsx(FormHelperTextWarning, {
    variant: "outlined"
  }, __jsx(FormattedMessage, {
    id: "yourTextGuru.recommendedKeyword"
  }), __jsx(Keyword, null, getRecommendedKeyword(seoData))));
};

export default YTGInputField;